export enum CapaciteEditStepEnum {
  REVENUS_MISE_FONDS = 'REVENUS_MISE_FONDS',
  DETTES = 'DETTES',
  HYPOTHEQUE = 'HYPOTHEQUE',
  DEPENSES_PAIEMENT = 'DEPENSES_PAIEMENT'
}
